"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The Report model module.
 * @module model/Report
 * @version 1.0.0
 */
var Report = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Report</code>.
   * App 报活报告
   * @alias module:model/Report
   */
  function Report() {
    _classCallCheck(this, Report);

    Report.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(Report, [{
    key: "getAppID",
    value:
    /**
         * Returns 应用唯一识别码(如 waterfall)
         * @return {String}
         */
    function getAppID() {
      return this.AppID;
    }
    /**
     * Sets 应用唯一识别码(如 waterfall)
     * @param {String} appID 应用唯一识别码(如 waterfall)
     */

  }, {
    key: "setAppID",
    value: function setAppID(appID) {
      this['AppID'] = appID;
    }
    /**
         * Returns 运行架构
         * @return {String}
         */

  }, {
    key: "getArch",
    value: function getArch() {
      return this.Arch;
    }
    /**
     * Sets 运行架构
     * @param {String} arch 运行架构
     */

  }, {
    key: "setArch",
    value: function setArch(arch) {
      this['Arch'] = arch;
    }
    /**
         * Returns 设备唯一识别码
         * @return {String}
         */

  }, {
    key: "getMachineID",
    value: function getMachineID() {
      return this.MachineID;
    }
    /**
     * Sets 设备唯一识别码
     * @param {String} machineID 设备唯一识别码
     */

  }, {
    key: "setMachineID",
    value: function setMachineID(machineID) {
      this['MachineID'] = machineID;
    }
    /**
         * Returns 运行系统
         * @return {String}
         */

  }, {
    key: "getOS",
    value: function getOS() {
      return this.OS;
    }
    /**
     * Sets 运行系统
     * @param {String} OS 运行系统
     */

  }, {
    key: "setOS",
    value: function setOS(OS) {
      this['OS'] = OS;
    }
    /**
         * Returns 发布形式, App/Service
         * @return {String}
         */

  }, {
    key: "getRelType",
    value: function getRelType() {
      return this.RelType;
    }
    /**
     * Sets 发布形式, App/Service
     * @param {String} relType 发布形式, App/Service
     */

  }, {
    key: "setRelType",
    value: function setRelType(relType) {
      this['RelType'] = relType;
    }
    /**
         * Returns 运行环境, e.g BareMetal/Docker/Electron/Systemd/Upstart
         * @return {String}
         */

  }, {
    key: "getRunIn",
    value: function getRunIn() {
      return this.RunIn;
    }
    /**
     * Sets 运行环境, e.g BareMetal/Docker/Electron/Systemd/Upstart
     * @param {String} runIn 运行环境, e.g BareMetal/Docker/Electron/Systemd/Upstart
     */

  }, {
    key: "setRunIn",
    value: function setRunIn(runIn) {
      this['RunIn'] = runIn;
    }
    /**
         * Returns 版本号
         * @return {String}
         */

  }, {
    key: "getVer",
    value: function getVer() {
      return this.Ver;
    }
    /**
     * Sets 版本号
     * @param {String} ver 版本号
     */

  }, {
    key: "setVer",
    value: function setVer(ver) {
      this['Ver'] = ver;
    }
  }], [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>Report</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Report} obj Optional instance to populate.
     * @return {module:model/Report} The populated <code>Report</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Report();

        if (data.hasOwnProperty('AppID')) {
          obj['AppID'] = _ApiClient["default"].convertToType(data['AppID'], 'String');
        }

        if (data.hasOwnProperty('Arch')) {
          obj['Arch'] = _ApiClient["default"].convertToType(data['Arch'], 'String');
        }

        if (data.hasOwnProperty('MachineID')) {
          obj['MachineID'] = _ApiClient["default"].convertToType(data['MachineID'], 'String');
        }

        if (data.hasOwnProperty('OS')) {
          obj['OS'] = _ApiClient["default"].convertToType(data['OS'], 'String');
        }

        if (data.hasOwnProperty('RelType')) {
          obj['RelType'] = _ApiClient["default"].convertToType(data['RelType'], 'String');
        }

        if (data.hasOwnProperty('RunIn')) {
          obj['RunIn'] = _ApiClient["default"].convertToType(data['RunIn'], 'String');
        }

        if (data.hasOwnProperty('Ver')) {
          obj['Ver'] = _ApiClient["default"].convertToType(data['Ver'], 'String');
        }
      }

      return obj;
    }
  }]);

  return Report;
}();
/**
 * 应用唯一识别码(如 waterfall)
 * @member {String} AppID
 */


Report.prototype['AppID'] = undefined;
/**
 * 运行架构
 * @member {String} Arch
 */

Report.prototype['Arch'] = undefined;
/**
 * 设备唯一识别码
 * @member {String} MachineID
 */

Report.prototype['MachineID'] = undefined;
/**
 * 运行系统
 * @member {String} OS
 */

Report.prototype['OS'] = undefined;
/**
 * 发布形式, App/Service
 * @member {String} RelType
 */

Report.prototype['RelType'] = undefined;
/**
 * 运行环境, e.g BareMetal/Docker/Electron/Systemd/Upstart
 * @member {String} RunIn
 */

Report.prototype['RunIn'] = undefined;
/**
 * 版本号
 * @member {String} Ver
 */

Report.prototype['Ver'] = undefined;
var _default = Report;
exports["default"] = _default;